// ======================================================================
// File Name       : TranslateCompleteContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form';
import * as MultiLanguageAction from '../../actions/MultiLanguageAction';
import { MULTI_LANGUAGE_EDIT, MULTI_LANGUAGE_PROCESS_RESULT_LIST } from '../../constants/PathConstants';
import ModalWrapper from '../modal/ModalWrapper';

class TranslateCompleteContainer extends React.Component {
  constructor(props) {
    super(props);
    this.getModalOptions = this.getModalOptions.bind(this);
    this.onOK = this.onOK.bind(this);
  }

  getModalOptions() {
    return {
      footerBtns: [
        { name: 'OK', onClick: this.onOK, variant: 'primary' },
      ],
    };
  }

  onOK() {
    const { invalid, multiLanguageEditForm } = this.props;
    if (invalid) {
      return;
    }
    this.props.hideModal();
    const { contentSecernId, languageCode } = multiLanguageEditForm.values;
    this.props.dispatch(MultiLanguageAction.saveMultiLanguageCode(languageCode));
    const params = {};
    params.contentSecernIdList = [contentSecernId];
    this.props.dispatch(MultiLanguageAction.refreshLanguageInfo(params));
  }

  render() {
    const { editSuccess, translateSuccess } = this.props;
    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.onOK}
      >
        <Row>
          <Col sm={12} className="text-center margin-bottom-20">
            {translateSuccess && (
              <div>
                <p>ドキュメントの翻訳を受け付けました。</p>
                <p className="padding-top-10">翻訳状況は
                  <a
                    role="button"
                    href={`${MULTI_LANGUAGE_PROCESS_RESULT_LIST}`}
                    rel="noopener noreferrer"
                  >
                    <u>処理結果画面</u>
                  </a>
                  で確認ができます。
                </p>
              </div>
            )}
            {editSuccess && (
              <div>
                <p>言語ファイルの変更を受け付けました。</p>
                <p className="padding-top-10">PDFファイルへの変換状況は
                  <a
                    role="button"
                    href={`${MULTI_LANGUAGE_PROCESS_RESULT_LIST}`}
                    rel="noopener noreferrer"
                  >
                    <u>処理結果画面</u>
                  </a>
                  で確認ができます。
                </p>
              </div>
            )}
          </Col>
        </Row>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { searchCondition } = state.page;
  const { editSuccess, translateSuccess } = state.multiLanguage;
  const { multiLanguageEditForm } = state.form;
  return {
    ...{ multiLanguageEditForm },
    editSuccess,
    translateSuccess,
    searchCondition,
    formValues: getFormValues('translateCompleteForm')(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'translateCompleteForm',
    touchOnChange: true,
    enableReinitialize: true,
  })(TranslateCompleteContainer),
);
